"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlledTextField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var debounce_1 = __importDefault(require("lodash/debounce"));
var react_component_library_1 = require("@esub-engineering/react-component-library");
var react_hook_form_1 = require("react-hook-form");
exports.ControlledTextField = react_1.default.memo(function (_a) {
    var variant = _a.variant, required = _a.required, control = _a.control, debounceTimeout = _a.debounceTimeout, trigger = _a.trigger, defaultValue = _a.defaultValue, _b = _a.onChange, onChange = _b === void 0 ? function () { } : _b, _c = _a.onBlur, onBlur = _c === void 0 ? function () { } : _c, enclosedTextFieldProps = _a.enclosedTextFieldProps, regularTextFieldProps = _a.regularTextFieldProps, disabled = _a.disabled, rest = __rest(_a, ["variant", "required", "control", "debounceTimeout", "trigger", "defaultValue", "onChange", "onBlur", "enclosedTextFieldProps", "regularTextFieldProps", "disabled"]);
    var _d = (0, react_hook_form_1.useController)({
        name: rest.name,
        control: control,
        defaultValue: defaultValue,
    }), _e = _d.field, ref = _e.ref, onChangeController = _e.onChange, onBlurController = _e.onBlur, fieldValue = _e.value, inputProps = __rest(_e, ["ref", "onChange", "onBlur", "value"]), _f = _d.fieldState, invalid = _f.invalid, error = _f.error;
    // NOTE: error text can be set in the form with yup
    var validationProps = {
        error: invalid,
        helperText: invalid ? error === null || error === void 0 ? void 0 : error.message : undefined,
    };
    var Component = variant === 'enclosed' ? react_component_library_1.EnclosedTextField : react_component_library_1.TextField;
    return ((0, jsx_runtime_1.jsx)(Component, __assign({}, rest, inputProps, validationProps, enclosedTextFieldProps, regularTextFieldProps, { fixedLabel: fieldValue !== '', disabled: disabled, inputRef: ref, value: defaultValue === '0' && !fieldValue ? defaultValue : fieldValue, onChange: function (event) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // TODO: fix type here
                onChange(event);
                onChangeController(event);
                (0, debounce_1.default)(function () {
                    trigger(rest.name);
                }, debounceTimeout);
                return [2 /*return*/];
            });
        }); }, onBlur: function (event) {
            onBlur(event);
            onBlurController();
        } })));
});
